<div class="ui-g ui-fluid">
  <div class="ui-g-12 ui-md-12 ui-lg-12">
    <div class="card card-w-title">
      <div class="ui-g-11 ui-md-11 ui-lg-11">
        <h3 class="title">Add New Customer</h3>
      </div>
      <div class="ui-g-1 ui-md-1 ui-lg-1 backButton" [routerLink]="['/customers']">
          <i class="fa fa-angle-left" aria-hidden="true"></i>
          Back
      </div>
      <div class="ui-g-12 ui-md-12 ui-lg-12 basic_info">Basic info</div>
      <div class="ui-g ui-g-12 form-group">
        <div class="ui-g-12 ui-md-2 ui-lg-2">
          <span class="labelStyle">Customer Code</span>
          <input type="text" pInputText name="customer_id" [(ngModel)]="customer_id" placeholder="Es. 12">
        </div>
        <div class="ui-g-12 ui-md-10 ui-lg-10"></div>
        <div class="ui-g-12 ui-md-6 ui-lg-6">
          <span class="labelStyle">Name</span>
          <input type="text" pInputText name="customer_name" [(ngModel)]="customer_code">
        </div>
        <div class="ui-g-12 ui-md-6 ui-lg-6">
          <span class="labelStyle">Surname</span>
          <input type="text" pInputText name="customer_surname" [(ngModel)]="customer_code">
        </div>
        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <span class="labelStyle">Fiscal Code</span>
          <input type="text" pInputText name="customer_fiscalcode" [(ngModel)]="customer_code">
        </div>
        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <div class="ui-g-12 ui-md-12 ui-lg-12" class="address_border_top">
            <span class="labelStyle" class="text_color">Address</span>
          </div>
        </div>
        <div class="ui-g-12 ui-md-8 ui-lg-8">
          <span class="labelStyle">Venue</span>
          <input type="text" pInputText name="customer_name" [(ngModel)]="customer_code">
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <span class="labelStyle">Number</span>
          <input type="text" pInputText name="customer_surname" [(ngModel)]="customer_code">
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <span class="labelStyle">Province</span>
          <p-dropdown [options]="cities" name="province" [style]="{'width':'100%'}" required></p-dropdown>
        </div>
        <div class="ui-g-12 ui-md-8 ui-lg-8">
          <span class="labelStyle">City</span>
          <p-dropdown [options]="cities" name="city" [style]="{'width':'100%'}" required></p-dropdown>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <span class="labelStyle">ZIP Code</span>
          <input type="text" pInputText name="customer_name" [(ngModel)]="customer_code">
        </div>
        <div class="ui-g-12 ui-md-8 ui-lg-8">
          <span class="labelStyle">Country</span>
          <p-dropdown [options]="cities" name="country" [style]="{'width':'100%'}" required></p-dropdown>
        </div>
        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <div class="ui-g-12 ui-md-12 ui-lg-12" class="borderstyle"></div>
        </div>
        <div class="ui-g-12 ui-md-6 ui-lg-6">
          <span class="labelStyle">Telephone</span>
          <input type="text" pInputText name="customer_name" [(ngModel)]="customer_code">
        </div>
        <div class="ui-g-12 ui-md-6 ui-lg-6">
          <span class="labelStyle">Mobile</span>
          <input type="text" pInputText name="customer_surname" [(ngModel)]="customer_code">
        </div>
        <div class="ui-g-12 ui-md-6 ui-lg-6">
          <span class="labelStyle">Email 1</span>
          <input type="text" pInputText name="customer_name" [(ngModel)]="customer_code">
        </div>
        <div class="ui-g-12 ui-md-6 ui-lg-6">
          <span class="labelStyle">Email 2</span>
          <input type="text" pInputText name="customer_surname" [(ngModel)]="customer_code">
        </div>
        <div class="ui-g-12 ui-md-1 ui-lg-1">
          <p-inputSwitch name="flagOpenRedemptionPeriod"></p-inputSwitch>
        </div>
        <div class="ui-g-12 ui-md-11 ui-lg-11">
          Send name and surname to the register
        </div>
        <div class="ui-g-12 ui-md-1 ui-lg-1">
          <p-inputSwitch name="flagOpenRedemptionPeriod"></p-inputSwitch>
        </div>
        <div class="ui-g-12 ui-md-11 ui-lg-11">
          Authorization general comunications
        </div>
        <div class="ui-g-12 ui-md-1 ui-lg-1">
          <p-inputSwitch name="flagOpenRedemptionPeriod"></p-inputSwitch>
        </div>
        <div class="ui-g-12 ui-md-11 ui-lg-11">
          Market Research
        </div>
        <div class="ui-g-12 ui-md-1 ui-lg-1">
          <p-inputSwitch name="flagOpenRedemptionPeriod"></p-inputSwitch>
        </div>
        <div class="ui-g-12 ui-md-11 ui-lg-11">
          Authorization Privacy
        </div>
        <div class="ui-g-12 ui-md-1 ui-lg-1">
          <p-inputSwitch name="flagOpenRedemptionPeriod"></p-inputSwitch>
        </div>
        <div class="ui-g-12 ui-md-11 ui-lg-11">
          profiling
        </div>
        <div class="ui-g-12 ui-md-1 ui-lg-1">
          <p-inputSwitch name="flagOpenRedemptionPeriod"></p-inputSwitch>
        </div>
        <div class="ui-g-12 ui-md-11 ui-lg-11">
          Marketing Activities
        </div>
        <div class="ui-g-12 ui-md-1 ui-lg-1">
          <p-inputSwitch name="flagOpenRedemptionPeriod"></p-inputSwitch>
        </div>
        <div class="ui-g-12 ui-md-11 ui-lg-11">
          Authorization purchase comunications
        </div>
        <div class="ui-g-12 ui-md-1 ui-lg-1">
          <p-inputSwitch name="flagOpenRedemptionPeriod"></p-inputSwitch>
        </div>
        <div class="ui-g-12 ui-md-11 ui-lg-11">
          Push Notifications code
        </div>
        <div class="ui-g-5 ui-md-5 ui-lg-5"></div>
        <div class="ui-g-2 ui-md-2 ui-lg-2">
          <button pButton type="button" label="CONFIRM" class="confirmButton"></button>
        </div>
        <div class="ui-g-5 ui-md-5 ui-lg-5"></div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/add/add.component.html